export const mapColorBar = {
  ml_accuracy: "#006DD9",
  ml_accuracy_yes: "#392699",
  ml_accuracy_no: "#9400B8",
  ml_accuracy_multi_choice: "#529FE8",
} as const;

export const mapOpacityColorBar = {
  ml_accuracy: "#A3D1F7",
  ml_accuracy_yes: "#6950E6",
  ml_accuracy_no: "#CA00EB",
  ml_accuracy_multi_choice: "#D1E5F8",
} as const;
